<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="font-serif">
        <router-link class="text-decoration--none" :to="{ name: 'editors' }">Editor</router-link>
        <v-icon>{{ icons.arrow }}</v-icon>
        <span class="text-capitalize">Create Editor</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="ma-4">
      <editor-form></editor-form>
    </div>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import EditorForm from './components/EditorForm'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'EditorCreate',

  components: {
    EditorForm,
    AppBarNavIcon
  },

  data () {
    return {
      icons: {
        arrow: mdiChevronRight
      }
    }
  }
}
</script>
